// extracted by mini-css-extract-plugin
export default {"errorTop":"NotFound_errorTop__6hvtZ"};